module.exports = __webpack_public_path__ + "static/media/ally_pro_web_1.da662e39.jpg";